import { Row } from 'antd'
import InfoNote from 'app/components/Core/Overview/Info'
import KButton from 'app/components/Modules/General/KButton'
import Icon from 'app/components/UI-Elements/General/Icon'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import TabBar from 'app/components/UI-Elements/Layout/TabBar/TabBar'
import { RecordType } from 'app/constants/GlobalTypes'
import { useCurrentCustomer } from 'app/lib/hooks/useCurrent'
import { useHelpUrl } from 'app/lib/hooks/useHelpUrl'
import { useRentalCreate } from 'app/lib/hooks/useRentalCreate'
import useTranslation from 'app/lib/hooks/useTranslation'
import { Routes } from 'app/routes/Routes'
import * as React from 'react'

import { PageProps } from '../../typing'

const CardItem: React.FC<{ icon: React.ReactNode; action: React.ReactNode }> = ({
  icon,
  action
}) => (
  <KCol className="text-center" card span={24}>
    <Row gutter={[0, 24]}>
      <KCol span={24} />
      <KCol span={24}>{icon}</KCol>
      <KCol span={24}>{action}</KCol>
      <KCol span={24} />
    </Row>
  </KCol>
)

const MobileOverview: React.FC<PageProps> = ({ route }) => {
  const { tRoute } = useTranslation({ scope: route.key })
  const customer = useCurrentCustomer()
  const { createRental, loading } = useRentalCreate()
  const helpCenterUrl = useHelpUrl()

  return (
    <Row style={{ height: '100%', backgroundColor: '#f1f1f1', marginTop: -15 }}>
      <InfoNote />
      <KCol span={24}>
        <Row className="mt-3" gutter={[0, 24]}>
          <CardItem
            icon={<Icon type="machines" />}
            action={
              <KButton
                type="primary"
                loading={loading}
                recordType={RecordType.overview}
                action="new_rental"
                onClick={() => createRental()}
                title={tRoute({ id: 'new_rental' })}
              />
            }
          />
          <CardItem
            icon={<Icon type="search" />}
            action={
              <KButton
                href={helpCenterUrl}
                type="primary"
                title={tRoute({ id: 'visit_help_center' })}
                icon={<Icon type="external_link_white" />}
              />
            }
          />
          <CardItem
            icon={<Icon type="phone" />}
            action={
              <KButton
                type="primary"
                recordType={RecordType.overview}
                action="problem_report"
                onClick={() => window.open(`tel:${customer?.owner_phone}`)}
                title={tRoute({ id: 'problem_report' })}
              />
            }
          />
        </Row>
      </KCol>
      <TabBar selected={Routes.Overview.collection().index} />
    </Row>
  )
}

export default MobileOverview
